import { apiClient } from "@/utils";
import { AxiosResponse } from "axios";
import { put } from "redux-saga/effects";
import * as actions from '@/store/actions';

export function* getArticleTypes() {
    try {
        const response: AxiosResponse = yield apiClient.get('/articles/types');

        yield put(actions.FETCH_ARTICLE_TYPES.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_ARTICLE_TYPES.failure(error));
    }
}
